// extracted by mini-css-extract-plugin
export default {"close":"button-close_close__KymuX"};